import {
  NEW_BOD_UPDATE_USER_INFORMATION,
  NEW_BOD_UPDATE_VERIFICATION_ID,
  NEW_BOD_UPDATE_USER_TOKEN,
  NEW_BOD_UPDATE_OFFERS,
  NEW_BOD_UPDATE_SCORING_TOKEN,
  NEW_BOD_UPDATE_OFFER_TENORS,
  NEW_BOD_LOADING,
  UPDATE_BOD_APPLICATION_ID,
  NEW_BOD_UPDATE_SA_CODE,
  NEW_BOD_UTM_LINK,
} from 'constants/clz';

const bodReducers = (state = {}, action) => {
  switch (action.type) {
    case NEW_BOD_UPDATE_USER_INFORMATION:
      return { ...state, user: { ...state.user, ...action.payload } };
    case NEW_BOD_UPDATE_VERIFICATION_ID:
      return {
        ...state,
        verificationID: action.payload,
      };
    case NEW_BOD_UPDATE_USER_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case NEW_BOD_UPDATE_SCORING_TOKEN: {
      const { user } = state;
      return {
        ...state,
        user: {
          ...user,
          token: action.payload,
        },
      };
    }
    case NEW_BOD_UPDATE_OFFERS:
      return {
        ...state,
        offers: action.payload,
      };
    case UPDATE_BOD_APPLICATION_ID:
      return {
        ...state,
        applicationCode: action.id,
      };
    case NEW_BOD_UPDATE_OFFER_TENORS:
      return {
        ...state,
        tenors: action.payload,
      };
    case NEW_BOD_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case NEW_BOD_UPDATE_SA_CODE:
      return {
        ...state,
        saInformation: action.payload,
      };
    case NEW_BOD_UTM_LINK:
      return {
        ...state,
        utm: action.payload,
      };
    default:
      return state;
  }
};

export default bodReducers;
